import React, { useRef } from 'react';
import ResponsiveTab from './ResponsiveTab';
import useScrollByXToActive from '../hooks/useScrollByXToActive';
import SkeletonWrapper from './skeleton/SkeletonWrapper';
import Nbsp from './Nbsp';
/*
  Takes an array of key value pairs, and a selected value. OnChange emits the newly selected value.
 */

/**
 * @typedef {object} ResponsiveTabMenuProps
 * @property {Array<Object>} [tabs]
 * @property {string|number|Object|boolean} [activeTab]
 * @property {(tabId: string | number) => void} [onChange]
 * @property {boolean} [loading]
 */

/**
 * @param {ResponsiveTabMenuProps} props
 */
const ResponsiveTabMenu = props => {
  const { onChange, tabs, activeTab, loading = false } = props;

  const containerRef = useRef(null);
  const setContainerActiveTab = useScrollByXToActive(containerRef, activeTab);

  const onActiveChanged = tabId => {
    setContainerActiveTab(tabId);
    onChange(tabId);
  };

  const buildTabs = tabs =>
    tabs.map(tabEntry => (
      <SkeletonWrapper key={tabEntry.value} show={loading} inheritParentSize={true}>
        <ResponsiveTab
          id={tabEntry.value}
          active={tabEntry.value === activeTab}
          dataTestId={`tab-${tabEntry.value}`}
          onClick={() => onActiveChanged(tabEntry.value)}>
          {tabEntry.displayName}
        </ResponsiveTab>
      </SkeletonWrapper>
    ));

  return (
    <div className='tabs-menu'>
      <div ref={containerRef} className='tabs-menu__tabs scrollBar'>
        {buildTabs(loading ? dummyTabs : tabs)}
      </div>
    </div>
  );
};

const dummyTabs = Array.from({ length: 2 }, (_, index) => ({
  value: index,
  displayName: <Nbsp />
}));

export default ResponsiveTabMenu;
